<script setup>
import { trans } from '@elements/translation';

const props = defineProps({
  invoiceUrl: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <li>
    <a :href="props.invoiceUrl" target="_blank">
      {{ trans('gestion.invoices.display') }}
    </a>
  </li>
</template>
